/* Herb Garden × Fable & Mane v2: announcement, header, menus, carousels, videos and the Our Journey page-lift scroll.
   Cart drawer, menu drawer and the product page stay in thg.js. No dependencies. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(sel)); }

  /* ---------- announcement: one message at a time, like F&M ---------- */
  function initAnnc() {
    $$('[data-fm-annc]').forEach(function (bar) {
      var msgs = $$('.fm-annc__msg', bar); if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
      }, 4500);
    });
  }

  /* ---------- header: logo turns into the seal once you scroll; expose header height ---------- */
  var headEl = null;
  function headerHeight() { return headEl ? Math.round(headEl.getBoundingClientRect().height) : 0; }
  function initHeader() {
    headEl = doc.querySelector('.thg-header-section') || doc.querySelector('[data-fm-header]');
    var hdr = doc.querySelector('[data-fm-header]');
    function onScroll() { if (hdr) hdr.classList.toggle('is-scrolled', window.pageYOffset > 40); }
    function setH() { root.style.setProperty('--fm-head', headerHeight() + 'px'); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setH);
    onScroll(); setH();
  }

  /* ---------- Shop mega menu + Discover dropdown ---------- */
  function initMenus() {
    var items = $$('[data-fm-menu]');
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function close(item) {
      item.classList.remove('is-open');
      var b = item.querySelector('[data-fm-menu-btn]'); if (b) b.setAttribute('aria-expanded', 'false');
    }
    function open(item) {
      items.forEach(function (o) { if (o !== item) close(o); });
      item.classList.add('is-open');
      var b = item.querySelector('[data-fm-menu-btn]'); if (b) b.setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (item) {
      var btn = item.querySelector('[data-fm-menu-btn]'); var t = null;
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) close(item); else open(item);
      });
      if (hoverable) {
        item.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { open(item); }, 80); });
        item.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { close(item); }, 180); });
      }
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(item); });
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (i) { if (i.classList.contains('is-open')) { close(i); var b = i.querySelector('[data-fm-menu-btn]'); if (b) b.focus(); } });
    });
    doc.addEventListener('click', function (e) { items.forEach(function (i) { if (!i.contains(e.target)) close(i); }); });
  }

  /* ---------- carousels: arrows + progress bar ---------- */
  function initCarousels() {
    $$('[data-fm-car]').forEach(function (car) {
      var track = car.querySelector('[data-fm-track]'); if (!track) return;
      var prev = car.querySelector('[data-fm-prev]'), next = car.querySelector('[data-fm-next]');
      var thumb = car.querySelector('[data-fm-thumb]'), bar = car.querySelector('[data-fm-bar]');
      function step() { var c = track.children[0]; if (!c) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap) || 0; var per = Math.max(1, Math.round((track.clientWidth + gap) / (c.getBoundingClientRect().width + gap))); return per * (c.getBoundingClientRect().width + gap); }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (thumb && bar) {
          var frac = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          bar.hidden = frac >= .995;
          var w = bar.clientWidth * frac; thumb.style.width = w + 'px';
          var x = max > 0 ? (track.scrollLeft / max) * (bar.clientWidth - w) : 0;
          thumb.style.transform = 'translateX(' + x + 'px)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- shoppable videos: autoplay muted in view, centre one lifts ---------- */
  function initVideos() {
    $$('[data-fm-vids]').forEach(function (wrap) {
      var cards = $$('.fm-vid', wrap);
      var vids = $$('video', wrap);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
          });
        }, { threshold: .4 });
        vids.forEach(function (v) { io.observe(v); });
      }
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fm-vid-toggle]'), m = e.target.closest('[data-fm-vid-mute]');
        var card = e.target.closest('.fm-vid'); if (!card) return;
        var v = card.querySelector('video'); if (!v) return;
        if (b) { if (v.paused) { v.play(); b.setAttribute('aria-label', 'Pause video'); } else { v.pause(); b.setAttribute('aria-label', 'Play video'); } b.classList.toggle('is-paused', v.paused); }
        if (m) { v.muted = !v.muted; m.classList.toggle('is-on', !v.muted); m.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off'); }
      });
      var track = wrap.querySelector('.fm-vids__track');
      function centre() {
        if (!track) return;
        var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = null, bd = 1e9;
        cards.forEach(function (c) { var r = c.getBoundingClientRect(); var d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = c; } });
        cards.forEach(function (c) { c.classList.toggle('is-center', c === best); });
      }
      if (track) { track.addEventListener('scroll', function () { window.requestAnimationFrame(centre); }, { passive: true }); centre(); }
    });
  }

  /* ---------- Our Journey: each chapter's title page lifts away to reveal the chapter already in place ---------- */
  function initStories() {
    var stories = $$('[data-fm-story]'); if (!stories.length) return;
    var parts = stories.map(function (s) {
      return { s: s, title: s.querySelector('[data-fm-story-title]'), block: s.querySelector('[data-fm-story-block]'), cont: s.querySelector('[data-fm-story-container]'), disp: s.querySelector('[data-fm-story-display]') };
    }).filter(function (p) { return p.title && p.block && p.cont && p.disp; });
    var H = 0;
    function layout() {
      H = headerHeight();
      root.style.setProperty('--fm-head', H + 'px');
      parts.forEach(function (p) {
        var th = p.title.offsetHeight;
        p.cont.style.setProperty('--fm-lift', th + 'px');
        p.block.style.height = (p.disp.offsetHeight + th) + 'px';
      });
      tick();
    }
    function tick() {
      var y = window.pageYOffset || root.scrollTop;
      parts.forEach(function (p) {
        var top = p.s.getBoundingClientRect().top + y;
        p.cont.classList.toggle('is-locked', y >= top - H + p.title.offsetHeight);
      });
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(layout);
    $$('img', doc.querySelector('[data-fm-stories]') || doc).forEach(function (im) { if (!im.complete) im.addEventListener('load', layout, { once: true }); });
    layout();
  }

  /* ---------- product page: quantity stepper ---------- */
  function initQty() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fm-qty]'); if (!b) return;
      var wrap = b.closest('.fm-qty'); var input = wrap && wrap.querySelector('input'); if (!input) return;
      var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-fm-qty'), 10);
      input.value = Math.max(1, Math.min(99, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    doc.addEventListener('change', function (e) {
      var input = e.target.closest('.fm-qty__input'); if (!input) return;
      var v = parseInt(input.value, 10); input.value = isNaN(v) ? 1 : Math.max(1, Math.min(99, v));
    });
  }

  /* ---------- product page: thumbnail strip arrows, slide arrows' end states, active thumb kept in view ---------- */
  function initPdpMedia() {
    $$('[data-fm-media]').forEach(function (m) {
      var track = m.querySelector('[data-thg-track]');
      var prev = m.querySelector('[data-thg-prev]'), next = m.querySelector('[data-thg-next]');
      var box = m.querySelector('.fm-pdp__thumbs'), list = m.querySelector('[data-fm-thumbs]');
      var up = m.querySelector('[data-fm-thumbs-prev]'), down = m.querySelector('[data-fm-thumbs-next]');
      function vertical() { return !!list && getComputedStyle(list).flexDirection === 'column'; }
      function stepThumbs(dir) {
        if (!list || !list.children[0]) return;
        var t = list.children[0], gap = parseFloat(getComputedStyle(list).rowGap) || parseFloat(getComputedStyle(list).columnGap) || 0;
        var by = (vertical() ? t.offsetHeight : t.offsetWidth) + gap;
        list.scrollBy(vertical() ? { top: dir * by * 2, behavior: reduce ? 'auto' : 'smooth' } : { left: dir * by * 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      function update() {
        if (track) {
          var max = track.scrollWidth - track.clientWidth;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
        }
        if (list) {
          var v = vertical();
          var lmax = v ? list.scrollHeight - list.clientHeight : list.scrollWidth - list.clientWidth;
          var pos = v ? list.scrollTop : list.scrollLeft;
          if (box) box.classList.toggle('is-static', lmax <= 2);
          if (up) up.disabled = pos <= 2;
          if (down) down.disabled = pos >= lmax - 2;
        }
      }
      function reveal(t) {
        if (!list || !t) return;
        var tr = t.getBoundingClientRect(), lr = list.getBoundingClientRect();
        if (vertical()) {
          var top = tr.top - lr.top + list.scrollTop, bottom = top + tr.height;
          if (top < list.scrollTop) list.scrollTo({ top: top, behavior: 'smooth' });
          else if (bottom > list.scrollTop + list.clientHeight) list.scrollTo({ top: bottom - list.clientHeight, behavior: 'smooth' });
        } else {
          var left = tr.left - lr.left + list.scrollLeft, right = left + tr.width;
          if (left < list.scrollLeft) list.scrollTo({ left: left, behavior: 'smooth' });
          else if (right > list.scrollLeft + list.clientWidth) list.scrollTo({ left: right - list.clientWidth, behavior: 'smooth' });
        }
      }
      if (up) up.addEventListener('click', function () { stepThumbs(-1); });
      if (down) down.addEventListener('click', function () { stepThumbs(1); });
      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      if (list) {
        list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
        if ('MutationObserver' in window) {
          new MutationObserver(function (muts) {
            muts.forEach(function (mu) { if (mu.target.classList && mu.target.classList.contains('is-on')) reveal(mu.target); });
          }).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
        }
      }
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  }

  /* ---------- product page: the following Add to Bag card steps aside over the footer, like F&M's ---------- */
  function initStick() {
    var stick = doc.querySelector('[data-thg-stick]'), foot = doc.querySelector('.fm-footer, .thg-footer');
    if (!stick || !foot || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { stick.classList.toggle('is-away', en[0].isIntersecting); }).observe(foot);
  }

  /* ---------- product FAQ: five questions, then Load More ---------- */
  function initFaq() {
    $$('[data-fm-faq]').forEach(function (f) {
      var more = f.querySelector('[data-fm-faq-more]'); if (!more) return;
      more.addEventListener('click', function () {
        var extra = $$('[data-fm-faq-extra]', f);
        extra.forEach(function (d) { d.hidden = false; });
        more.hidden = true;
        var s = extra[0] && extra[0].querySelector('summary'); if (s) s.focus();
      });
    });
  }

  function boot() { initAnnc(); initHeader(); initMenus(); initCarousels(); initVideos(); initStories(); initQty(); initPdpMedia(); initStick(); initFaq(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
